/**
 * =========================================================
 * LMS WEB CLIENT - Entry Point (React 18)
 * =========================================================
 * หน้าที่: Frontend สำหรับนักเรียน/ผู้ใช้ทั่วไป
 * ใช้: React 18 + React Router + Zustand + React Query + Tailwind CSS
 * 
 * อัลกอริทึม React:
 * 1. Virtual DOM - Diffing algorithm (O(n) - tree comparison)
 * 2. Reconciliation - เปรียบเทียบ tree เก่ากับใหม่ แล้ว update DOM จริง
 * 3. Component Lifecycle - mount → update → unmount
 * 4. Hooks - useState, useEffect, useContext, useMemo, useCallback
 * =========================================================
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import axios from 'axios';
import App from './App';
import './index.css';

const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://lms-workers.glock000jjjjj.workers.dev';
axios.defaults.baseURL = apiBaseUrl;

// อัลกอริทึม React Query:
// 1. QueryClient จัดการ cache ทั้งหมด
// 2. แต่ละ query มี key (array) สำหรับ identify
// 3. ถ้า key เดิม → ใช้ cache ถ้ายังไม่หมดอายุ (staleTime)
// 4. Background refetch: ถ้า focus window → ดึงข้อมูลใหม่เงียบ ๆ

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 นาที ถือว่า fresh
      cacheTime: 10 * 60 * 1000, // 10 นาที เก็บ cache
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
